import { createSelector } from "@reduxjs/toolkit";

import { Authority, UserCurrent, UserRole } from "../../../types/userCurrent";
import { RootState } from "../../store";

export const currentRolesSelector = createSelector(
    (state: RootState): Authority[] =>
        state.auth.currentUser?.authorities ?? [],
    (authorities): UserRole[] => authorities.map((it) => it.authority),
);

export const currentUserFullNameSelector = (state: RootState): string | undefined => state.auth.currentUser?.fullName;
export const currentUserEmailSelector = (state: RootState): string | undefined => state.auth.currentUser?.email;
export const currentUserAccountNameSelector = (state: RootState): string | undefined => state.auth.currentUser?.userProfile.accountName;
export const currentUserWalletSelector = (state: RootState): string | undefined => state.auth.currentUser?.userProfile.wallet;
export const currentUserPartyNameSelector = (state: RootState): string | undefined => state.auth.currentParty?.partyName;
export const currentUserSelector = (state: RootState): UserCurrent | null =>
    state.auth.currentUser;
